import { getConfidenceColor } from '@app/modules/logger/screens/stream/components/audit/transcriptions/utils';
import { alpha, Typography } from '@mui/material';

type TranscriptionWordProps = {
  text: string;
  confidence: number;
  showEfficiency: boolean;
  isHighlighted: boolean;
  /** Whole-word search hit (substring match on normalized text). */
  isSearchMatch?: boolean;
  /** When true, click enters edit mode instead of seeking playback. */
  isEditMode?: boolean;
  onClick: () => void;
};

/**
 * Clickable transcript word; highlights when playback is inside its time range.
 * Optional efficiency mode tints the background from engine confidence (same scale as legacy table).
 * Search matches use bold weight (efficiency background is skipped for matched words).
 * Playback text color (info) when not a search match.
 */
export function TranscriptionWord({
  text,
  confidence,
  showEfficiency,
  isHighlighted,
  isSearchMatch = false,
  isEditMode = false,
  onClick,
}: TranscriptionWordProps) {
  return (
    <Typography
      component="span"
      variant="body2"
      onClick={(event) => {
        event.stopPropagation();
        onClick();
      }}
      sx={(theme) => ({
        cursor: isEditMode ? 'text' : 'pointer',
        '&:hover': { color: isEditMode ? 'text.primary' : 'info.main' },
        ...(showEfficiency && { bgcolor: getConfidenceColor(confidence), borderRadius: '2px' }),
        ...(isHighlighted && { color: 'info.main' }),
        ...(isSearchMatch && {
          fontWeight: theme.typography.fontWeightMedium,
          textDecoration: 'underline',
          backgroundColor: alpha(theme.palette.primary.main, 0.25),
          borderRadius: '2px',
        }),
      })}
    >
      {text}
    </Typography>
  );
}
